import Document from './Document'
import '../Documents/Documents.scss'

export default Document